import { type FragmentOf, graphql, readFragment } from "gql.tada";

import { EffectRow } from "./EffectRow";

export const RuleEngineEffectCreateGroupFragment = graphql(`
  fragment RuleEngineEffectCreateGroupFields on RuleEngineEffectCreateGroupPayload {
    __typename
    effectKind
    stepId
    groupId
    groupOrder
    applied
    skipReason
  }
`);

interface Props {
  data: FragmentOf<typeof RuleEngineEffectCreateGroupFragment>;
}

export function RuleEngineEffectCreateGroupPayload({ data }: Props) {
  const p = readFragment(RuleEngineEffectCreateGroupFragment, data);
  return (
    <EffectRow
      applied={p.applied}
      appliedColor="teal"
      appliedLabel="CREATE_GROUP"
      skipReason={p.skipReason}
    >
      step {p.stepId.slice(0, 8)} · group {p.groupId.slice(0, 8)} (order{" "}
      {p.groupOrder})
    </EffectRow>
  );
}
